<template>
  <v-app>
    <v-app-bar app dark color="secondary" flat>
      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = true"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link to="/"> Operating Systems </router-link>
      </v-toolbar-title>
      <v-icon class="ml-2" color="grey">mdi-crane</v-icon>
      <v-icon color="grey">mdi-crane</v-icon>
      <v-icon color="grey">mdi-crane</v-icon>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn to="/" text>
          <span class="mr-2">Home</span>
        </v-btn>
        <v-btn to="/lectures" text>
          <span class="mr-2">Lectures</span>
        </v-btn>
        <v-btn to="/assignments" text>
          <span class="mr-2">Assignments</span>
        </v-btn>
        <v-btn to="/hours" text>
          <span class="mr-2">Hours</span>
        </v-btn>
        <v-btn to="/staff" text>
          <span class="mr-2">Staff</span>
        </v-btn>
        <v-btn to="/resources" text>
          <span class="mr-2">Resources</span>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      class="hidden-md-and-up"
      fixed
      temporary
    >
      <v-list nav>
        <v-list-item-group active-class="text">
          <v-list-item to="/">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>
          <v-list-item to="/lectures">
            <v-list-item-icon>
              <v-icon>mdi-human-male-board</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Lectures</v-list-item-title>
          </v-list-item>
          <v-list-item to="/assignments">
            <v-list-item-icon>
              <v-icon>mdi-clipboard-text</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Assignments</v-list-item-title>
          </v-list-item>
          <v-list-item to="/hours">
            <v-list-item-icon>
              <v-icon>mdi-calendar-month</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Hours</v-list-item-title>
          </v-list-item>
          <v-list-item to="/staff">
            <v-list-item-icon>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Staff</v-list-item-title>
          </v-list-item>
          <v-list-item to="/resources">
            <v-list-item-icon>
              <v-icon>mdi-hammer-wrench</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Resources</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>

    <v-footer padless color="secondary" dark>
      <v-row justify="center" no-gutters>
        <v-col class="py-1 text-center overline" cols="12">
          © Brown University 2022 CS167 Staff
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    drawer: false,
  }),
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Staatliches&display=swap");

main {
  background-color: var(--v-primary-base);
}

/* "Operating Systems" title in navbar */
.v-toolbar__title > a {
  font-family: "Staatliches", sans-serif;
  font-size: 1.5em !important;
  text-decoration: none;
  color: white;
}
</style>
